import React, { useEffect, useState } from "react";
import Sidebar from "../../../Components/Sidebar/Sidebar";
import DateTimeField from "../../../Components/Commons/Forms/DateTimeField";
import NumberInput from "../../../Components/Commons/Forms/NumberInput";
import BtnSave from "../../../Components/Commons/Buttons/BtnSave";
// import Table from "../../../Components/Commons/Table/Table"
import { Button, Checkbox, Radio, Select } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import "../../../Components/Patients/Patients.css";
import {
  createFPE,
  createVital,
} from "../../Helpers/API/VitalSignsApi/VitalSignsApi";
import { getAllDoctors } from "../../Helpers/API/DoctorApi/DoctorApi";

import BtnAdd from "../../Commons/Buttons/BtnAdd";
import { createQueue } from "../../Helpers/API/QueueApi/QueueApi";
import TextArea from "../../Commons/Forms/TextArea";
import { getRole, getUser } from "../../Helpers/Utilities/Common";
import TextField from "../../Commons/Forms/TextField";
import DateField from "../../Commons/Forms/DateField";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { formatDateWithTimeHMS } from "../../../Helpers/Utils/Common";

const { Option } = Select;

function FPE() {
  const id = useParams();
  const role = getRole();
  const userId = getUser();
  const navigate = useNavigate();
  const state = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [doctors, setDoctors] = useState([]);
  const [checkedPastMedicalHistory, setCheckedPastMedicalHistory] = useState(
    []
  );
  const [pastAllergies, setPastAllergies] = useState([""]);
  const [pastCancers, setPastCancers] = useState([""]);
  const [pastOthers, setPastOthers] = useState([""]);

  const [checkedFamilyPastMedicalHistory, setCheckedFamilyPastMedicalHistory] =
    useState([]);
  const [familyPastAllergies, setFamilyPastAllergies] = useState([""]);
  const [familyPastCancers, setFamilyPastCancers] = useState([""]);
  const [familyPastOthers, setFamilyPastOthers] = useState([""]);

  const [addFPE, setAddFPEData] = useState({
    blood_type: "",
    has_smoking_history: "0",
    has_drinking_history: "0",
    smoking_year: "",
    drinking_year: "",
    illicit_drugs: "no",
    is_sexually_active: "0",
    has_family_planning: "0",
    menarche: "",
    period_duration: "",
    gravidity: "",
    parity: "",
    delivery_type: "",
    has_menopause: "0",
    menopause_age: "",
    hepatitis_type: "",
    highest_bp: "",
    pulmonary_tuberculosis_category: "",
    extrapulmonary_tuberculosis_category: "",
    family_hepatitis_type: "",
    family_highest_bp: "",
    family_pulmonary_tuberculosis_category: "",
    family_extrapulmonary_tuberculosis_category: "",
  });

  const pastMedicalHistoryOptions = [
    "Allergies",
    "Bronchial asthma",
    "Cancer",
    "Cerebrovascular Disease",
    "COPD/emphysema/bronchitis",
    "Coronary Artery Disease",
    "Diabetes Mellitus",
    "Epilepsy/Seizure Disorder",
    "Extrapulmonary Tuberculosis",
    "Heart Disease",
    "Hepatitis",
    "Hyerlipidemia",
    "Hypertension",
    "Peptic Ulcer",
    "Pneumonia",
    "Stroke",
    "Thyroid Disease",
    "Tuberculosis",
    "Urinary Tract Infection",
    "Mental Illness",
    "None",
    "Others",
  ];

  const familyPastMedicalHistoryOptions = [
    "Allergy",
    "Asthma",
    "Cancer",
    "Cerebrovascular Disease",
    "Coronary Artery Disease",
    "Diabetes Mellitus",
    "Epilepsy/Seizure Disorder",
    "Extrapulmonary Tuberculosis",
    "Hepatitis",
    "Hyerlipidemia",
    "Hypertension",
    "Peptic Ulcer",
    "Pneumonia",
    "Thyroid Disease",
    "Tuberculosis",
    "Urinary Tract Infection",
    "Mental Illness",
    "None",
    "Others",
  ];

  const handleAddChange = (e) => {
    const { name, value } = e.target;
    setAddFPEData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handlePastMedicalChange = (option) => {
    setCheckedPastMedicalHistory((prev) => {
      // If "None" is being checked
      if (option === "None") {
        if (prev.includes("None")) {
          // If "None" is already checked, uncheck it
          return prev.filter((item) => item !== "None");
        } else {
          // If "None" is being checked, clear all other options
          return ["None"];
        }
      }
      // If any other option is being checked
      else {
        if (prev.includes(option)) {
          // If option is already checked, uncheck it
          const newChecked = prev.filter((item) => item !== option);

          // If unchecking "Allergies", reset the allergies array to [""]
          if (option === "Allergies") {
            setPastAllergies([""]);
          }
          // If unchecking "Cancer", reset the cancers array to [""]
          if (option === "Cancer") {
            setPastCancers([""]);
          }
          // If unchecking "Others", reset the others array to [""]
          if (option === "Others") {
            setPastOthers([""]);
          }

          return newChecked;
        } else {
          // If option is being checked, remove "None" if it exists and add the new option
          const newChecked = prev.filter((item) => item !== "None");
          return [...newChecked, option];
        }
      }
    });
  };

  const handleFamilyPastMedicalChange = (option) => {
    setCheckedFamilyPastMedicalHistory((prev) => {
      if (option === "None") {
        if (prev.includes("None")) {
          return prev.filter((item) => item !== "None");
        } else {
          return ["None"];
        }
      } else {
        if (prev.includes(option)) {
          // If option is already checked, uncheck it
          const newChecked = prev.filter((item) => item !== option);

          // If unchecking "Allergy", reset the family allergies array to [""]
          if (option === "Allergy") {
            setFamilyPastAllergies([""]);
          }
          // If unchecking "Cancer", reset the family cancers array to [""]
          if (option === "Cancer") {
            setFamilyPastCancers([""]);
          }
          // If unchecking "Others", reset the family others array to [""]
          if (option === "Others") {
            setFamilyPastOthers([""]);
          }

          return newChecked;
        } else {
          // If option is being checked, remove "None" if it exists and add the new option
          const newChecked = prev.filter((item) => item !== "None");
          return [...newChecked, option];
        }
      }
    });
  };

  // Check if "None" is checked
  const isNoneChecked = checkedPastMedicalHistory.includes("None");
  const isNoneFamilyPastChecked =
    checkedFamilyPastMedicalHistory.includes("None");

  // Check if any other option besides "None" is checked
  const isOtherChecked = checkedPastMedicalHistory.some(
    (option) => option !== "None"
  );
  const isOtherFamilyPastChecked = checkedFamilyPastMedicalHistory.some(
    (option) => option !== "None"
  );

  // Functions for Allergies
  function addAllergyField(type) {
    if (type === "past_medical") {
      setPastAllergies([...pastAllergies, ""]);
    } else {
      setFamilyPastAllergies([...familyPastAllergies, ""]);
    }
  }

  function removeAllergyField(index, type) {
    if (type === "past_medical") {
      if (pastAllergies?.length > 1) {
        const newPastAllergies = [...pastAllergies];
        newPastAllergies.splice(index, 1);
        setPastAllergies(newPastAllergies);
      }
    } else {
      if (familyPastAllergies?.length > 1) {
        const newFamilyPastAllergies = [...familyPastAllergies];
        newFamilyPastAllergies.splice(index, 1);
        setFamilyPastAllergies(newFamilyPastAllergies);
      }
    }
  }

  //Function for allergies
  function handleAllergyChange(index, value, type) {
    if (type === "past_medical") {
      const newPastAllergies = [...pastAllergies];
      newPastAllergies[index] = value;
      setPastAllergies(newPastAllergies);

      setAddFPEData((prevState) => ({
        ...prevState,
        allergies: newPastAllergies?.filter((info) => info?.trim() !== ""),
      }));
    } else {
      const newFamilyPastAllergies = [...familyPastAllergies];
      newFamilyPastAllergies[index] = value;
      setFamilyPastAllergies(newFamilyPastAllergies); // Fixed: should setFamilyPastAllergies

      setAddFPEData((prevState) => ({
        ...prevState,
        family_allergies: newFamilyPastAllergies?.filter(
          (info) => info?.trim() !== ""
        ),
      }));
    }
  }

  // Functions for Cancers
  function addCancerField(type) {
    if (type === "past_medical") {
      setPastCancers([...pastCancers, ""]);
    } else {
      setFamilyPastCancers([...familyPastCancers, ""]);
    }
  }

  function removeCancerField(index, type) {
    if (type === "past_medical") {
      if (pastCancers?.length > 1) {
        const newPastCancers = [...pastCancers];
        newPastCancers.splice(index, 1);
        setPastCancers(newPastCancers);
      }
    } else {
      if (familyPastCancers?.length > 1) {
        const newFamilyPastCancers = [...familyPastCancers];
        newFamilyPastCancers.splice(index, 1);
        setFamilyPastCancers(newFamilyPastCancers);
      }
    }
  }

  function handleCancerChange(index, value, type) {
    if (type === "past_medical") {
      const newPastCancers = [...pastCancers];
      newPastCancers[index] = value;
      setPastCancers(newPastCancers);

      setAddFPEData((prevState) => ({
        ...prevState,
        cancers: newPastCancers?.filter((info) => info?.trim() !== ""),
      }));
    } else {
      const newFamilyPastCancers = [...familyPastCancers];
      newFamilyPastCancers[index] = value;
      setFamilyPastCancers(newFamilyPastCancers); // Fixed: should setFamilyPastCancers

      setAddFPEData((prevState) => ({
        ...prevState,
        family_cancers: newFamilyPastCancers?.filter(
          (info) => info?.trim() !== ""
        ),
      }));
    }
  }

  // Functions for Others
  function addOtherField(type) {
    if (type === "past_medical") {
      setPastOthers([...pastOthers, ""]);
    } else {
      setFamilyPastOthers([...familyPastOthers, ""]);
    }
  }

  function removeOtherField(index, type) {
    if (type === "past_medical") {
      if (pastOthers?.length > 1) {
        const newPastOthers = [...pastOthers];
        newPastOthers.splice(index, 1);
        setPastOthers(newPastOthers);
      }
    } else {
      if (familyPastOthers?.length > 1) {
        const newFamilyPastOthers = [...familyPastOthers];
        newFamilyPastOthers.splice(index, 1);
        setFamilyPastOthers(newFamilyPastOthers);
      }
    }
  }

  const handleOtherChange = (index, value, type) => {
    if (type === "past_medical") {
      const newPastOthers = [...pastOthers];
      newPastOthers[index] = value;
      setPastOthers(newPastOthers);

      setAddFPEData((prevState) => ({
        ...prevState,
        past_med_history_others: newPastOthers?.filter(
          (info) => info?.trim() !== ""
        ),
      }));
    } else {
      const newFamilyPastOthers = [...familyPastOthers];
      newFamilyPastOthers[index] = value;
      setFamilyPastOthers(newFamilyPastOthers); // Fixed: should setFamilyPastOthers

      setAddFPEData((prevState) => ({
        ...prevState,
        fam_past_med_history_others: newFamilyPastOthers?.filter(
          (info) => info?.trim() !== ""
        ),
      }));
    }
  };

  async function handleSubmit() {
    // setIsLoading(true);
    // await _createQueue();
    await _createFpeData(false);
    // setIsLoading(false);
  }

  async function handleSchedule() {
    setIsLoading(true);
    await _createFpeData(true);
    setIsLoading(false);
  }

  async function _createFpeData(navigateToProfile) {
    const payload = {
      ...addFPE,
      chief_complaint: state?.state?.complaints?.chief_complaint || "",
      complaint_2: state?.state?.complaints?.complaint_2 || "",
      complaint_3: state?.state?.complaints?.complaint_3 || "",
      complaint_4: state?.state?.complaints?.complaint_4 || "",
      complaint_5: state?.state?.complaints?.complaint_5 || "",
      complaint_6: state?.state?.complaints?.complaint_6 || "",
      complaint_8: state?.state?.complaints?.complaint_8 || "",
      first_mens_period: state?.state?.complaints?.first_mens_period || "",
      last_mens_period: state?.state?.complaints?.last_mens_period || "",
      preg_count: state?.state?.complaints?.preg_count || "",
      general_survey: state?.state?.complaints?.general_survey || "",

      weight: state?.state?.vitals?.weight,
      weight_in_lb: state?.state?.vitals?.weight_in_lb,
      height: state?.state?.vitals?.height,
      height_in_ft: state?.state?.vitals?.height_in_ft,
      height_in_inch: state?.state?.vitals?.height_in_inch,
      bmi: state?.state?.vitals?.bmi,
      ibw: state?.state?.vitals?.ibw,
      waist: state?.state?.vitals?.waist,
      hip: state?.state?.vitals?.hip,
      whr: state?.state?.vitals?.whr,
      temperature: state?.state?.vitals?.temperature,
      bp: state?.state?.vitals?.bp,
      heart_rate: state?.state?.vitals?.heart_rate,
      respiratory_rate: state?.state?.vitals?.respiratory_rate,
      oxygen_saturation: state?.state?.vitals?.oxygen_saturation,
      right_eye_vision: state?.state?.vitals?.right_eye_vision,
      left_eye_vision: state?.state?.vitals?.left_eye_vision,
      last_meal: formatDateWithTimeHMS(state?.state?.vitals?.last_meal) || "",
      length: state?.state?.vitals?.length,
      head_circumference: state?.state?.vitals?.head_circumference,
      skinfold_thickness: state?.state?.vitals?.skinfold_thickness,
      body_circumference_waist: state?.state?.vitals?.body_circumference_waist,
      hip_in_cm: state?.state?.vitals?.hip_in_cm,
      limbs: state?.state?.vitals?.limbs,
      muac: state?.state?.vitals?.muac, //middle_upper_arm_circumference

      past_med_history: checkedPastMedicalHistory.filter(
        (item) => item !== "None"
      ),
      fam_past_med_history: checkedFamilyPastMedicalHistory.filter(
        (item) => item !== "None"
      ),

      allergies: pastAllergies?.filter((allergy) => allergy?.trim() !== ""),
      cancers: pastCancers?.filter((cancer) => cancer?.trim() !== ""),
      past_med_history_others: pastOthers?.filter(
        (other) => other?.trim() !== ""
      ),
      family_allergies: familyPastAllergies?.filter(
        (allergy) => allergy?.trim() !== ""
      ),
      family_cancers: familyPastCancers?.filter(
        (cancer) => cancer?.trim() !== ""
      ),
      fam_past_med_history_others: familyPastOthers?.filter(
        (other) => other?.trim() !== ""
      ),
    };
    const response = await createFPE(payload, id.id);
    if (response.status !== 200) {
      toast.error(response.response.data.messages.error_messages[0]);
    } else {
      toast.success(response.data.message);
      await _createQueue();
      if (navigateToProfile) {
        setTimeout(() => {
          navigate("/patients/profile/" + id.id);
          localStorage.setItem("isCheck", JSON.stringify(true));
          localStorage.setItem("isTrue", JSON.stringify(true));
          localStorage.setItem("vitalSignLab", JSON.stringify("vital_signs"));
          localStorage.setItem("openAppointmentModal", JSON.stringify(true));
        }, 2000);
      }
    }
  }

  async function _createQueue() {
    const response = await createQueue({
      patient_id: id.id,
      status: "queued",
      complaint: state?.state?.complaints?.chief_complaint,
      doctor_id: state?.state?.doctor_id,
    });

    if (response.data) {
      toast.success(response.data.message);
      navigate("/queue");
    } else if (response.error) {
      response.error.data.messages.error_messages.forEach((err) => {
        toast.error(err);
      });
    }
  }

  async function fetchAllDoctors() {
    const response = await getAllDoctors();
    if (response.data) {
      const mappedDoctors = response.data.data.map((doctor) => ({
        label: doctor.doctor_name,
        value: doctor.id,
        id: doctor.id,
        doctor_name: doctor.doctor_name,
      }));
      setDoctors(mappedDoctors);
    } else {
      setDoctors([]);
    }
  }

  useEffect(() => {
    fetchAllDoctors();
  }, []);

  useEffect(() => {
    if (role === "director" || role === "pcp" || role === "specialist") {
      setSelectedDoctor(userId);
    }
  }, [role]);

  return (
    <div className="App">
      <Sidebar />
      <div className="col p-5 pt-4 profile-container">
        <div className="ml-7 col font-big font-bold">FPE Form</div>
        <div className="ml-7">
          <div className="row">
            <div className="col-sm-11">
              <div className="row mt-3">
                <div className="col-3">
                  <div className="row">
                    <span>
                      Blood Type <label className="red"> *</label>
                    </span>
                    <Select
                      placeholder="SELECT"
                      className="custom-select-height w-full"
                      value={addFPE.blood_type}
                      options={[
                        { value: "A+", label: "A+" },
                        { value: "B+", label: "B+" },
                        { value: "AB+", label: "AB+" },
                        { value: "O+", label: "O+" },
                        { value: "A-", label: "A-" },
                        { value: "B-", label: "B-" },
                        { value: "AB-", label: "AB-" },
                        { value: "O-", label: "O-" },
                      ]}
                      size="small"
                      onChange={(value) =>
                        handleAddChange({
                          target: { name: "blood_type", value },
                        })
                      }
                      showSearch
                    />
                  </div>
                </div>
              </div>
              <label
                className="mt-4"
                style={{
                  fontWeight: "bold",
                  textDecoration: "underline",
                }}
              >
                Personal/Social History
              </label>
              <div className="row mt-3">
                <div className="col">
                  <p className="form-label align-left">
                    1. Do you smoke cigar, cigarette, e-cigarette, vape, or
                    other similar products?
                  </p>
                  <Radio.Group
                    className="w-full mt-2"
                    name="has_smoking_history"
                    value={addFPE?.has_smoking_history}
                    onChange={handleAddChange}
                  >
                    <Radio value="1">Yes</Radio>
                    <Radio value="0">No</Radio>
                  </Radio.Group>
                </div>
              </div>
              {addFPE?.has_smoking_history === "1" && (
                <>
                  <div className="row mt-3">
                    <div className="col-4">
                      <NumberInput
                        required={true}
                        id="smoking_year"
                        name="smoking_year"
                        formLabel={`Number of years:`}
                        value={addFPE?.smoking_year}
                        onChange={handleAddChange}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="row mt-3">
                <div className="col">
                  <p className="form-label align-left">
                    2. Do you drink alcohol or alcohol-containing beverages?
                  </p>
                  <Radio.Group
                    className="w-full mt-2"
                    name="has_drinking_history"
                    value={addFPE?.has_drinking_history}
                    onChange={handleAddChange}
                  >
                    <Radio value="1">Yes</Radio>
                    <Radio value="0">No</Radio>
                  </Radio.Group>
                </div>
              </div>
            </div>
            {addFPE?.has_drinking_history === "1" && (
              <>
                <div className="row mt-3">
                  <div className="col-4">
                    <NumberInput
                      required={true}
                      id="drinking_year"
                      name="drinking_year"
                      formLabel={`Number of years:`}
                      value={addFPE?.drinking_year}
                      onChange={handleAddChange}
                    />
                  </div>
                </div>
              </>
            )}
            <div className="row mt-3">
              <div className="col">
                <p className="form-label align-left">3. Illicit Drugs?</p>
                <Radio.Group
                  className="w-full mt-2"
                  name="illicit_drugs"
                  value={addFPE?.illicit_drugs}
                  onChange={handleAddChange}
                >
                  <Radio value="yes">Yes</Radio>
                  <Radio value="no">No</Radio>
                  <Radio value="quit">Quit</Radio>
                </Radio.Group>
              </div>
            </div>
            <hr className="mt-3" />
            <label
              style={{
                fontWeight: "bold",
                textDecoration: "underline",
              }}
            >
              Past Medical History
            </label>
            <div className="row mt-3">
              {pastMedicalHistoryOptions.map((option, index) => (
                <div key={index} className="col-sm-4 mb-2">
                  <Checkbox
                    checked={checkedPastMedicalHistory.includes(option)}
                    onChange={() => handlePastMedicalChange(option)}
                    disabled={
                      (option === "None" && isOtherChecked) ||
                      (option !== "None" && isNoneChecked)
                    }
                  >
                    {option}
                  </Checkbox>
                </div>
              ))}
            </div>
            <div className="row">
              {/* Past Medical Others Section */}
              {checkedPastMedicalHistory.includes("Others") &&
                !isNoneChecked && (
                  <div className="col-4 mt-3">
                    <label>If others, pls specify:</label>
                    {pastOthers?.map((other, index) => (
                      <div key={index} className="row mt-2 align-items-center">
                        <div className="col">
                          <TextField
                            id={`other-${index}`}
                            name={`other-${index}`}
                            placeholder="Enter other condition"
                            value={other}
                            size="sm"
                            onChange={(e) =>
                              handleOtherChange(
                                index,
                                e.target.value,
                                "past_medical"
                              )
                            }
                          />
                        </div>
                        <div
                          className="col-2 d-flex align-items-center"
                          style={{ marginTop: "-15px" }}
                        >
                          {pastOthers?.length > 1 && (
                            <Button
                              type="danger"
                              icon={<DeleteOutlined />}
                              size="small"
                              onClick={() =>
                                removeOtherField(index, "past_medical")
                              }
                              style={{ marginRight: "8px" }}
                            />
                          )}
                          {index === pastOthers?.length - 1 && (
                            <Button
                              type="primary"
                              icon={<PlusOutlined />}
                              size="small"
                              onClick={() => addOtherField("past_medical")}
                            />
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              {/* Past Medical Allergies Section */}
              {checkedPastMedicalHistory.includes("Allergies") &&
                !isNoneChecked && (
                  <div className="col-4 mt-3">
                    <label>Specify Allergies:</label>
                    {pastAllergies?.map((allergy, index) => (
                      <div key={index} className="row mt-2 align-items-center">
                        <div className="col">
                          <TextField
                            id={`allergy-${index}`}
                            name={`allergy-${index}`}
                            placeholder="Enter allergy"
                            value={allergy}
                            size="sm"
                            onChange={(e) =>
                              handleAllergyChange(
                                index,
                                e.target.value,
                                "past_medical"
                              )
                            }
                          />
                        </div>
                        <div
                          className="col-2 d-flex align-items-center"
                          style={{ marginTop: "-15px" }}
                        >
                          {pastAllergies?.length > 1 && (
                            <Button
                              type="danger"
                              icon={<DeleteOutlined />}
                              size="small"
                              onClick={() =>
                                removeAllergyField(index, "past_medical")
                              }
                              style={{ marginRight: "8px" }}
                            />
                          )}
                          {index === pastAllergies?.length - 1 && (
                            <Button
                              type="primary"
                              icon={<PlusOutlined />}
                              size="small"
                              onClick={() => addAllergyField("past_medical")}
                            />
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              {/* Past Medical Cancer Section */}
              {checkedPastMedicalHistory.includes("Cancer") &&
                !isNoneChecked && (
                  <div className="col-4 mt-3">
                    <label>Specify organ(s) with cancer:</label>
                    {pastCancers?.map((cancer, index) => (
                      <div key={index} className="row mt-2 align-items-center">
                        <div className="col">
                          <TextField
                            id={`cancer-${index}`}
                            name={`cancer-${index}`}
                            placeholder="Enter cancer type"
                            value={cancer}
                            size="sm"
                            onChange={(e) =>
                              handleCancerChange(
                                index,
                                e.target.value,
                                "past_medical"
                              )
                            }
                          />
                        </div>
                        <div
                          className="col-2 d-flex align-items-center"
                          style={{ marginTop: "-15px" }}
                        >
                          {pastCancers?.length > 1 && (
                            <Button
                              type="danger"
                              icon={<DeleteOutlined />}
                              size="small"
                              onClick={() =>
                                removeCancerField(index, "past_medical")
                              }
                              style={{ marginRight: "8px" }}
                            />
                          )}
                          {index === pastCancers?.length - 1 && (
                            <Button
                              type="primary"
                              icon={<PlusOutlined />}
                              size="small"
                              onClick={() => addCancerField("past_medical")}
                            />
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
            </div>
            <div className="row mt-3">
              {checkedPastMedicalHistory.includes("Hepatitis") &&
                !isNoneChecked && (
                  <div className="col-4">
                    <TextField
                      id="hepatitis_type"
                      name="hepatitis_type"
                      formLabel="Specify hepatitis type"
                      size="sm"
                      onChange={handleAddChange}
                    />
                  </div>
                )}
              {checkedPastMedicalHistory.includes("Hypertension") &&
                !isNoneChecked && (
                  <div className="col-4">
                    <TextField
                      id="highest_bp"
                      name="highest_bp"
                      formLabel="Highest blood pressure (mmHg)"
                      size="sm"
                      onChange={handleAddChange}
                    />
                  </div>
                )}
              {checkedPastMedicalHistory.includes("Tuberculosis") &&
                !isNoneChecked && (
                  <div className="col-4">
                    <TextField
                      id="pulmonary_tuberculosis_category"
                      name="pulmonary_tuberculosis_category"
                      formLabel="Specify Pulmonary Tuberculosis Category"
                      size="sm"
                      onChange={handleAddChange}
                    />
                  </div>
                )}
            </div>
            <div className="row">
              {checkedPastMedicalHistory.includes(
                "Extrapulmonary Tuberculosis"
              ) &&
                !isNoneChecked && (
                  <div className="col-4">
                    <TextField
                      id="extrapulmonary_tuberculosis_category"
                      name="extrapulmonary_tuberculosis_category"
                      formLabel="Specify Extrapulmonary Tuberculosis Category"
                      size="sm"
                      onChange={handleAddChange}
                    />
                  </div>
                )}
            </div>
            <hr className="mt-3" />
            <label
              style={{
                fontWeight: "bold",
                textDecoration: "underline",
              }}
            >
              Family Past Medical History
            </label>
            <div className="row mt-3 text-left">
              {familyPastMedicalHistoryOptions.map((option, index) => (
                <div key={index} className="col-sm-12 mb-2 text-left">
                  <Checkbox
                    checked={checkedFamilyPastMedicalHistory.includes(option)}
                    onChange={() => handleFamilyPastMedicalChange(option)}
                    disabled={
                      (option === "None" && isOtherFamilyPastChecked) ||
                      (option !== "None" && isNoneFamilyPastChecked)
                    }
                  >
                    {option}
                  </Checkbox>
                </div>
              ))}
            </div>
            {/* Family Past Medical Others Section */}
            {checkedFamilyPastMedicalHistory.includes("Others") &&
              !isNoneFamilyPastChecked && (
                <div className="col-4 mt-3">
                  <label>If others, pls specify:</label>
                  {familyPastOthers?.map((other, index) => (
                    <div key={index} className="row mt-2 align-items-center">
                      <div className="col">
                        <TextField
                          id={`other-${index}`}
                          name={`other-${index}`}
                          placeholder="Enter other condition"
                          value={other}
                          size="sm"
                          onChange={(e) =>
                            handleOtherChange(
                              index,
                              e.target.value,
                              "family_past_medical"
                            )
                          }
                        />
                      </div>
                      <div
                        className="col-2 d-flex align-items-center"
                        style={{ marginTop: "-15px" }}
                      >
                        {familyPastOthers?.length > 1 && (
                          <Button
                            type="danger"
                            icon={<DeleteOutlined />}
                            size="small"
                            onClick={() =>
                              removeOtherField(index, "family_past_medical")
                            }
                            style={{ marginRight: "8px" }}
                          />
                        )}
                        {index === familyPastOthers?.length - 1 && (
                          <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            size="small"
                            onClick={() => addOtherField("family_past_medical")}
                          />
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            {/* Family Past Medical Allergies Section */}
            {checkedFamilyPastMedicalHistory.includes("Allergy") &&
              !isNoneFamilyPastChecked && (
                <div className="col-4 mt-3">
                  <label>Specify Allergies:</label>
                  {familyPastAllergies?.map((allergy, index) => (
                    <div key={index} className="row mt-2 align-items-center">
                      <div className="col">
                        <TextField
                          id={`allergy-${index}`}
                          name={`allergy-${index}`}
                          placeholder="Enter allergy"
                          value={allergy}
                          size="sm"
                          onChange={(e) =>
                            handleAllergyChange(
                              index,
                              e.target.value,
                              "family_past_medical"
                            )
                          }
                        />
                      </div>
                      <div
                        className="col-2 d-flex align-items-center"
                        style={{ marginTop: "-15px" }}
                      >
                        {familyPastAllergies?.length > 1 && (
                          <Button
                            type="danger"
                            icon={<DeleteOutlined />}
                            size="small"
                            onClick={() =>
                              removeAllergyField(index, "family_past_medical")
                            }
                            style={{ marginRight: "8px" }}
                          />
                        )}
                        {index === familyPastAllergies?.length - 1 && (
                          <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            size="small"
                            onClick={() =>
                              addAllergyField("family_past_medical")
                            }
                          />
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            {/* Family Past Medical Allergies Section */}
            {checkedFamilyPastMedicalHistory.includes("Cancer") &&
              !isNoneFamilyPastChecked && (
                <div className="col-4 mt-3">
                  <label>Specify organ(s) with cancer:</label>
                  {familyPastCancers?.map((cancer, index) => (
                    <div key={index} className="row mt-2 align-items-center">
                      <div className="col">
                        <TextField
                          id={`cancer-${index}`}
                          name={`cancer-${index}`}
                          placeholder="Enter cancer type"
                          value={cancer}
                          size="sm"
                          onChange={(e) =>
                            handleCancerChange(
                              index,
                              e.target.value,
                              "family_past_medical"
                            )
                          }
                        />
                      </div>
                      <div
                        className="col-2 d-flex align-items-center"
                        style={{ marginTop: "-15px" }}
                      >
                        {familyPastCancers?.length > 1 && (
                          <Button
                            type="danger"
                            icon={<DeleteOutlined />}
                            size="small"
                            onClick={() =>
                              removeCancerField(index, "family_past_medical")
                            }
                            style={{ marginRight: "8px" }}
                          />
                        )}
                        {index === familyPastCancers?.length - 1 && (
                          <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            size="small"
                            onClick={() =>
                              addCancerField("family_past_medical")
                            }
                          />
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            <div className="row mt-3">
              {checkedFamilyPastMedicalHistory.includes("Hepatitis") &&
                !isNoneFamilyPastChecked && (
                  <div className="col-4">
                    <TextField
                      id="family_hepatitis_type"
                      name="family_hepatitis_type"
                      formLabel="Specify hepatitis type"
                      size="sm"
                      onChange={handleAddChange}
                    />
                  </div>
                )}
              {checkedFamilyPastMedicalHistory.includes("Hypertension") &&
                !isNoneFamilyPastChecked && (
                  <div className="col-4">
                    <TextField
                      id="family_highest_bp"
                      name="family_highest_bp"
                      formLabel="Highest blood pressure (mmHg)"
                      size="sm"
                      onChange={handleAddChange}
                    />
                  </div>
                )}
              {checkedFamilyPastMedicalHistory.includes("Tuberculosis") &&
                !isNoneFamilyPastChecked && (
                  <div className="col-4">
                    <TextField
                      id="family_pulmonary_tuberculosis_category"
                      name="family_pulmonary_tuberculosis_category"
                      formLabel="Specify Pulmonary Tuberculosis Category"
                      size="sm"
                      onChange={handleAddChange}
                    />
                  </div>
                )}
            </div>
            <div className="row">
              {checkedFamilyPastMedicalHistory.includes(
                "Extrapulmonary Tuberculosis"
              ) &&
                !isNoneFamilyPastChecked && (
                  <div className="col-4">
                    <TextField
                      id="family_extrapulmonary_tuberculosis_category"
                      name="family_extrapulmonary_tuberculosis_category"
                      formLabel="Specify Extrapulmonary Tuberculosis Category"
                      size="sm"
                      onChange={handleAddChange}
                    />
                  </div>
                )}
            </div>
            <hr className="mt-3" />
            <label
              style={{
                fontWeight: "bold",
                textDecoration: "underline",
              }}
            >
              Sexual History
            </label>
            <div className="row mt-3">
              <div className="col">
                <p className="form-label align-left">1. Sexually active?</p>
                <Radio.Group
                  className="w-full mt-2"
                  name="is_sexually_active"
                  value={addFPE?.is_sexually_active}
                  onChange={handleAddChange}
                >
                  <Radio value="1">Yes</Radio>
                  <Radio value="0">No</Radio>
                </Radio.Group>
              </div>
            </div>

            {state?.state?.patient_sex?.toUpperCase() === "FEMALE" && (
              <>
                <hr className="mt-3" />
                <label
                  style={{
                    fontWeight: "bold",
                    textDecoration: "underline",
                  }}
                >
                  OB-Gyne History
                </label>
                <div className="row mt-3">
                  <div className="col">
                    <p className="form-label align-left">
                      1. With access to family planning counselling?
                    </p>
                    <Radio.Group
                      className="w-full mt-2"
                      name="has_family_planning"
                      value={addFPE?.has_family_planning}
                      onChange={handleAddChange}
                    >
                      <Radio value="1">Yes</Radio>
                      <Radio value="0">No</Radio>
                    </Radio.Group>
                  </div>
                </div>
                <p className="form-label align-left mt-3">
                  2. Menstrual History
                </p>
                <div className="row mt-2">
                  <div className="col-3">
                    <NumberInput
                      id="menarche"
                      name="menarche"
                      formLabel={`Menarche (years old)`}
                      size={`sm`}
                      onChange={handleAddChange}
                    />
                  </div>
                  <div className="col-3">
                    <NumberInput
                      id="period_duration"
                      name="period_duration"
                      formLabel={`Period Duration (days)`}
                      size={`sm`}
                      onChange={handleAddChange}
                    />
                  </div>
                </div>
                <p className="form-label align-left">3. Pregnancy History</p>
                <div className="row mt-2">
                  <div className="col-3">
                    <NumberInput
                      id="gravidity"
                      name="gravidity"
                      formLabel={`Gravidity (no. of pregnancy)`}
                      size={`sm`}
                      onChange={handleAddChange}
                    />
                  </div>
                  <div className="col-3">
                    <NumberInput
                      id="parity"
                      name="parity"
                      formLabel={`Parity (no. of delivery)`}
                      size={`sm`}
                      onChange={handleAddChange}
                    />
                  </div>
                  <div className="col-3">
                    <NumberInput
                      id="delivery_type"
                      name="delivery_type"
                      formLabel={`Type of Delivery`}
                      size={`sm`}
                      onChange={handleAddChange}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-3">
                    <p className="form-label align-left">4. Menopause?</p>
                    <Radio.Group
                      className="w-full mt-2"
                      name="has_menopause"
                      value={addFPE?.has_menopause}
                      onChange={handleAddChange}
                    >
                      <Radio value="1">Yes</Radio>
                      <Radio value="0">No</Radio>
                    </Radio.Group>
                  </div>
                  {addFPE?.has_menopause === "1" && (
                    <>
                      <div className="col-3">
                        <NumberInput
                          id="menopause_age"
                          name="menopause_age"
                          formLabel={`If yes, what age? (years old)`}
                          size={`sm`}
                          onChange={handleAddChange}
                        />
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
          </div>
          <div className="row justify-content-end mt-5 mb-3">
            <div className="col-2">
              <BtnAdd
                label={"Submit"}
                size={"sm"}
                onClick={handleSubmit}
                isClicked={isLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FPE;
